import React from "react";
import s from "./RoadmapPage.pcss";

const RoadmapPage = () => {
    return (
        <div className={s.feedbackContainer}>
            <iframe
                height="100%"
                width="100%"
                src="https://portal.productboard.com/pwrkl7ryy8dsbnutcogqhk3j"
                frameBorder="0"
                data-test-id="roadmap-iframe"
            />
        </div>
    );
};

export default RoadmapPage;
